import type { FunctionComponent } from 'react';

import { Button } from '@kanda-libs/ks-design-library';

import MarkCompleteModal from './MarkCompleteModal';
import useMarkJobAsCompleteButtonProps from './useMarkJobAsCompleteButtonProps';

export interface MarkJobAsCompleteButtonProps {}

export const MarkJobAsCompleteButton: FunctionComponent<
  MarkJobAsCompleteButtonProps
> = () => {
  const { showContent, onClick, callback, isSubmitting, isLoading } =
    useMarkJobAsCompleteButtonProps();

  if (!showContent) {
    return <></>;
  }

  return (
    <>
      <Button.Text
        id="staff-mark-job-as-complete"
        onClick={onClick}
        label="Mark job as complete"
        size={40}
        className="ml-6"
        isLoading={isLoading}
        disabled={isSubmitting}
      />
      <MarkCompleteModal callback={callback} isSubmitting={isSubmitting} />
    </>
  );
};

export default MarkJobAsCompleteButton;
